import styled from 'styled-components'
import { Label } from '../styles/Typography'
import { theme } from '../../theme/theme'
import { Permission } from '../../api/ester-b2b-api/private/users/types'
import { useTranslation } from 'react-i18next'

type Props = {
  lastLogin: string | null
  isManager: boolean
  permission: Permission[]
}

export const EmployeesTableTag = ({ lastLogin, isManager, permission }: Props) => {
  const { t } = useTranslation()
  const tags = []

  if (!lastLogin) {
    tags.push(
      <InvitationPendingContainer>
        <Label>{t('common.roles.invitedTag')}</Label>
      </InvitationPendingContainer>
    )
  }

  if (permission.includes('ADMIN')) {
    tags.push(
      <IsManagerContainer key="admin">
        <Label>{t('common.roles.adminTag')}</Label>
      </IsManagerContainer>
    )
  }

  if (isManager) {
    tags.push(
      <IsNotManagerContainer key="manager">
        <Label>{t('common.roles.managerTag')}</Label>
      </IsNotManagerContainer>
    )
  }

  return tags.length > 0 ? <TagsContainer>{tags}</TagsContainer> : null
}

const SharedContainer = styled.div`
  display: inline-block;
  padding: 6px ${theme.spacing.xsmall}px;
  margin-left: ${theme.spacing.small}px;
  border-radius: ${theme.spacing.tiny}px;
`

const InvitationPendingContainer = styled(SharedContainer)`
  background-color: ${theme.color.yellowLight};
  color: ${theme.color.black};
`

const IsManagerContainer = styled(SharedContainer)`
  background-color: ${theme.color.brightBlue};
  color: ${theme.color.white};
`
const IsNotManagerContainer = styled(IsManagerContainer)`
  background-color: ${theme.color.plumMid};
`

const TagsContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.xsmall}px;

  ${SharedContainer} {
    margin-left: 0;
  }
`
